import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M10.77 11.93a7.46 7.46 0 0 1-.35-2.43 7.65 7.65 0 0 1 15.3 0 7.42 7.42 0 0 1-.36 2.3l-1.24-.4a6.09 6.09 0 0 0 .3-1.9 6.35 6.35 0 0 0-12.7 0 6.25 6.25 0 0 0 .28 2z' }),
  React.createElement('path', { d: 'M21 18.17a4.65 4.65 0 0 1 3.17 4.31c0 2.63-1.75 5-4 6.51h-9a17.23 17.23 0 0 1-3-9.37c0-2.65 3.79-5 8.21-5A.63.63 0 0 0 17 14V9a2 2 0 0 1 2.31-2A2.17 2.17 0 0 1 21 9.07z' })
));